import { render } from "./WeightChart.vue?vue&type=template&id=440f221a&ts=true"
import script from "./WeightChart.vue?vue&type=script&lang=ts"
export * from "./WeightChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__